export default __webpack_public_path__ + "static/media/logo.22d6a29b.svg";